import React from 'react';
import CoordinationClient from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { EndUserActivateNudge, MESSAGE_ID } from './nudge/index.tsx';
import { useShowProjectPagesSpotlightSeenStatus } from './utils/hooks.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { MESSAGE_ID } from './nudge';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { useShowProjectPagesSpotlightSeenStatus } from './utils/hooks';

interface Props {
	isFocussed: boolean;
	children: React.ReactElement;
}

type StopFunction = () => void;
interface CoordinationStopProviderProps {
	stop?: StopFunction;
	children: (arg1: StopFunction | undefined) => React.ReactElement;
}

const CoordinationStopProvider = ({ stop, children }: CoordinationStopProviderProps) =>
	children(stop);

/*
This provider just manages coordination with EP to start/stop the message.
We have to check if the user is enrolled in the message by trying "start" it (via CoordinationClient)
If they are, we then use statsig to determine if they actually need to be shown the nudge
*/

export const EndUserActivateNudgeProvider = ({ children, isFocussed }: Props) => {
	const [showSpotlight, markAsSeen] = useShowProjectPagesSpotlightSeenStatus(MESSAGE_ID);

	return showSpotlight ? (
		<CoordinationClient messageId={MESSAGE_ID} fallback={children}>
			<CoordinationStopProvider>
				{(stop) => (
					<EndUserActivateNudge stop={stop} isFocussed={isFocussed} markAsSeen={markAsSeen}>
						{children}
					</EndUserActivateNudge>
				)}
			</CoordinationStopProvider>
		</CoordinationClient>
	) : (
		children
	);
};
